import { transferValueToInput } from '../mod_form/form';

let m;
let y;

if ($(".aside .calendar").length){
	m = +$('#monthNum').text(); //отображаемый месяц(номер)
	y = +$('#year').text(); //отображаемый год
}

const formatDate = n => {
	if (n.length == 1 && n < 10) n = `0${n}`;
	return n;
}

//получить сегодняшние месяц-день в формате 11-01
const getCurDayMonth = () => {

	let today = new Date();
	let curDay = today.getDate();
	let curMonth = today.getMonth() + 1;

	//if (curDay < 10) curDay = `0${curDay}`; //добавить 0, если число меньше 10
	//if (curMonth < 10) curMonth = `0${curMonth}`;
	curDay = formatDate(curDay);
	curMonth = formatDate(curMonth);

	return `${curMonth}-${curDay}`
} 
//показать праздники
const showEvents = () => {
	$('.calendar__days button').each(function() {
		let btn = $(this)
		let btnDay = $(this).children('time').attr('datetime')		

		$('.calendar__event').each(function(){

			let eventDay = $(this).attr('data-date')
			if(btnDay == eventDay) {
				$(btn).addClass('event');//активный класс только у дня с праздниками
			}
		});

	})
}

//выбрать день календаря
const chooseDay = () => {
	//console.log('выбрать день')

	$('.calendar__days button').not('.disabled').on('click', function() {
		let day = $(this);
		$('.calendar__days button').each(function(){
			$(this).removeClass('active');
		})
		//если календарь в форме, то сделать активным день по клику
		if ($("#dateContent .calendar").length) $(this).addClass('active');

		let val = $(this).children('time').attr('datetime');

		$('.calendar__event').each(function(){
			$(this).css('display', 'none');
			if($(this).attr('data-date') == val) {
				$(this).css('display', 'block');//показать описание праздников за конкретный день
				day.addClass('active');//активный класс только у дня с праздниками
			}
		});
	})
}

//перевести месяц (3) и год (2021) в нужный формат (2021-03) для запроса
const transformDate = (mnth, yr, n) => {

	mnth = mnth + n;

	if (mnth == 13) {
		mnth = 1;
		yr++;
	};
	if (mnth == 0) {
		mnth = 12;
		yr--;
	}
	m = mnth; //обновить отображаемый месяц
	y = yr; //обновить отображаемый год

	//if (mnth < 10) mnth = `0${mnth}`; //добавить 0, если число меньше 10
	mnth = formatDate(mnth);

	let newFormatDate = `${yr}-${mnth}`;
	return newFormatDate;
}

//получить верстку календаря на другой месяц
const setCalendar = (select) => {

	$.ajax({url:'/ajax.php?mid=26&action=get_month&month=' + select, 
		method:"GET",
		dataType: "html",
		success: function(result) {
			$('.aside .calendar').html(result);
			showEvents();
			chooseDay();	
		},
		error:function(){
			console.log( "Error!" );
		},
		complete:function(){
			pressArrow();
		}
	});
}
	
//нажать на стрелку
const pressArrow = () => {

	$('.calendar__arrows span').on('click', function(e) {

		//если календарь на бок.панели 
		if ($(".aside .calendar").length){

			if($(e.target).text() == $('#prev').text()) {	
				setCalendar(transformDate(m, y, -1));
			}
			if($(e.target).text() == $('#next').text()) {
				setCalendar(transformDate(m, y, 1));
			}
		}
		//если календарь в форме
		if ($("#dateContent .calendar").length){

			if($(e.target).text() == $('#prev').text()) {
				setCalendarForm(transformDate(m, y, -1));
			}
			if($(e.target).text() == $('#next').text()) {
				setCalendarForm(transformDate(m, y, 1));
			}
		}
	});
}

if ($(".aside .calendar").length){
	showEvents();
	chooseDay();
	pressArrow();
}

/*-----  Календарь в форме  -------*/

const getAvailableDays = (date) => {
	// получить сегодняшнюю дату
	let today = new Date();
	let currentDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());

	// получить дату для каждого дня календаря и сравнить с сегодняшней

	$(".calendar__days button").not( ".disabled" ).each(function(){
		let day = $(this).text();
		let month = date.split('-')[1];
		let year = date.split('-')[0];

		//атрибут fulldate
		//let fullday = day;
		//if (fullday < 10) fullday = `0${fullday}`; //добавить 0, если число меньше 10
		day = formatDate(day)
		month = formatDate(month)

		$(this).children('time').attr('fulldate', `${day}.${month}.${year}`);//передать в атрибут дату в формате 26.11.2021

		let btnDate = new Date(year, month-1, day);


		if(currentDate > btnDate) $(this).addClass('inactive');
	})
	return currentDate;
}

//получить текущий месяц-год
const getCurrentMonthYear = () => {
	let currentDate = new Date();
	let currentMonth = currentDate.getMonth()+1
	let currentYear = currentDate.getFullYear()

	m = currentMonth;
	y = currentYear;
	let date = `${currentYear}-${currentMonth}`

	return date;
}


//получить верстку календаря
const setCalendarForm = (select=currentDate) => {	

	$.ajax({url:`/ajax.php?mid=26&action=get_month&month=${select}&no_events=1`, 
		method:"GET",
		dataType: "html",
		success: function(result) {

			$('#dateContent').html('');
			$('#dateContent').html(result);

			transferValueToInput();
			getAvailableDays(select);
			chooseDay();

		},
		error:function(){
			console.log( "Error!" );
		},
		complete:function(){
			pressArrow();
		}
	});
}

if ($("#dateContent").length){

	var currentDate = getCurrentMonthYear();
	setCalendarForm();
	pressArrow();
}











